import { useState, useEffect, useRef } from 'react';
import {Routes, Route } from "react-router-dom";
import './App.css';
import Header from '../src/components/header/Header'
import Hero from './components/hero/Hero';
import Services from './components/services/Services';
import Faq from './components/faq/Faq';
import Footer from './components/footer/Footer';
import BookServiceHero from './components/bookServiceHero/BookServiceHero';
import AboutUs from './components/about/Aboutus';
import CompanyStats from './components/companyStats/CompanyStats';
import RequestPage from './pages/RequestPage';
import Brands from './components/Brands/Brands';
import ContactSection from './components/contactSection/ContactSection';
import CallButton from './components/callButton/CallButton';
import NotFound from './components/NotFound';
import ScrollToTop from './components/ScrollTop';
import ScrollUpButton from './components/ScrollUpButton';

function App() {
  const aboutRef = useRef(null);
  const faqRef = useRef(null);
  const reviewRef = useRef(null);
  const serviceRef = useRef(null)
  const contactRef = useRef(null)
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <Header 
        aboutRef={aboutRef} 
        faqRef={faqRef} 
        reviewRef={reviewRef} 
        serviceRef={serviceRef}
        contactRef = {contactRef}
        open={open} 
        setOpen={setOpen} 
        close={close} 
        setClose={setClose} 
        scrolled={scrolled} 
      />
      <CallButton></CallButton>
      <main className='appContent'>
        <ScrollToTop></ScrollToTop>
        <ScrollUpButton></ScrollUpButton>
        <Routes>
          <Route path="/" element={
            <>
              <Hero></Hero>
              <BookServiceHero />
              <Brands></Brands>
              <Services ref={serviceRef} />
              <CompanyStats />
              <AboutUs ref={aboutRef} />
              <Faq ref={faqRef} />
              <ContactSection></ContactSection>
              <Footer ref={contactRef} />
            </>
          } />
          <Route path="/requestPage" element={<RequestPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

    </>
  );
}

export default App;
